import React, { useEffect, useState } from "react";
import Side from "./Side/Side";
import Start from "./Main/Start";
import Network from "./Main/Network";
import Payment from "./Main/Payment";
import Create from "./Main/Create";
import Graph from "./Main/Graph";
import { motion } from "framer-motion";

export default function Guides() {
  const [tab, setTab] = useState("start");
  const [isLoading, setIsLoading] = useState(true);
  const lazyDummy = () => {
    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
  };
  useEffect(() => {
    lazyDummy();
  }, []);
  return (
    <div className="layout">
      <div className="auto__container">
        <h3>Guides</h3>
        <div className="layout__inner box">
          {isLoading ? (
            <div className="layoutSide">
              <div className="layoutSide__btn placeholder"></div>
              <div className="layoutSide__btn placeholder"></div>
              <div className="layoutSide__btn placeholder"></div>
              <div className="layoutSide__btn placeholder"></div>
              <div className="layoutSide__btn placeholder"></div>
            </div>
          ) : (
            <Side tab={tab} setTab={setTab} />
          )}
          {isLoading ? (
            <div className="layoutMain placeholder"></div>
          ) : (
            <>
              {tab === "start" && (
                <motion.div
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.2 }}
                  exit={{ opacity: 0, y: 10 }}
                  className="layoutMain"
                >
                  <Start />
                </motion.div>
              )}
              {tab === "network" && (
                <motion.div
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.2 }}
                  exit={{ opacity: 0, y: 10 }}
                  className="layoutMain"
                >
                  <Network />
                </motion.div>
              )}
              {tab === "invoice-payment" && (
                <motion.div
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.2 }}
                  exit={{ opacity: 0, y: 10 }}
                  className="layoutMain"
                >
                  <Payment />
                </motion.div>
              )}
              {tab === "invoice-creation" && (
                <motion.div
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.2 }}
                  exit={{ opacity: 0, y: 10 }}
                  className="layoutMain"
                >
                  <Create />
                </motion.div>
              )}
              {tab === "graphs" && (
                <motion.div
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.2 }}
                  exit={{ opacity: 0, y: 10 }}
                  className="layoutMain"
                >
                  <Graph />
                </motion.div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
